import { FilterToolbar } from '@/components/filter-toolbar/filter-toolbar';
import { useAIModelsQueryParams } from '@/modules/gpt-chats/hooks/use-aimodel';

import { useTranslation } from 'react-i18next';

export function AIModelsFilterToolbar() {
  const { t } = useTranslation();
  const { queryParams, setQueryParams } = useAIModelsQueryParams();

  const changeHandler = (key: string, value: any) => {
    setQueryParams((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetHandler = () => setQueryParams(null);

  return (
    <FilterToolbar
      filters={[
        { key: 'search', type: 'SearchInput', label: '' },
        {
          key: 'types',
          type: 'MultiSelect',
          label: t('TYPE'),
          props: {
            options: [
              { label: t('OFFICIAL_API'), value: 'official' },
              { label: t('OPEN_DEPLOYMENT'), value: 'open' },
            ],
          },
        },
      ]}
      values={{
        search: queryParams.search,
        types: queryParams.types,
      }}
      defaultValues={{
        search: '',
        types: [],
      }}
      onChange={changeHandler}
      onReset={resetHandler}
    />
  );
}
